var isKeyframesTarget = function (v) {
    return Array.isArray(v);
};

export { isKeyframesTarget };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.js
// module id = 34
// module chunks = 0